import { roadmapVisibilityConditionsSchema } from "src/stores/models/roadmap-visibility-conditions";
import { InferType, array, boolean, date, number, object, string } from "yup";

export const roadmapCardSchema = object({
  id: string().uuid().required(),
  title: string().required(),
  cardKey: string().required(),
  order: number().nullable().optional(),
  enabled: boolean().required(),
  description: string().required(),
  parentStageKey: string().required(),
  helpCenterArticleId: string().nullable().optional(),
  visibilityConditions: roadmapVisibilityConditionsSchema.nullable().optional(),
  organizationId: string().uuid().nullable().optional(),
  deviceId: string().uuid().nullable().optional(),
  createdAt: date().required(),
  updatedAt: date().required(),
});

export type RoadmapCard = InferType<typeof roadmapCardSchema>;

export const roadmapCardsSchema = array().of(roadmapCardSchema);

export type RoadmapCards = InferType<typeof roadmapCardsSchema>;
